/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const CUSTOMER_REVIEWS_ID = 'customer-reviews';

export const CUSTOMER_REVIEWS_HASH = `#${CUSTOMER_REVIEWS_ID}`;
